// 👥 Employés E4b — Section 5 : Vêtements (clé RBAC `vetements`). EmployeeVetements est le seul propriétaire des données
// (quotas /vetements/quotas, distributions, taille préférée via PUT partiel). L'ancien dict `employee.vetements` est affiché en archive.
import { Shirt } from 'lucide-react';
import { SectionFiche } from './SectionFiche';
import { EmployeeVetements } from '@/components/EmployeeVetements';

export function SectionVetements({ employee }) {
  const archive = employee.vetements?.historique || [];
  return (
    <SectionFiche cle="vetements" titre="Vêtements & quotas" icone={Shirt}>
      <EmployeeVetements employeeId={employee.id} employeeNom={`${employee.prenom} ${employee.nom}`} />
      {archive.length > 0 && (
        <div className="mt-4 border-t pt-3" data-testid="vetements-archive">
          <p className="text-xs text-slate-500 mb-1">Archive — allocation {employee.vetements.annee} (ancien formulaire, lecture seule)</p>
          <ul className="space-y-1">
            {archive.map((h, i) => (
              <li key={h.id || h._id || i} className="flex justify-between text-sm bg-slate-50 rounded px-3 py-1.5"><span>{h.description} <span className="text-xs text-slate-500">{h.date}</span></span><span className="font-semibold">{h.montant} $</span></li>
            ))}
          </ul>
        </div>
      )}
    </SectionFiche>
  );
}
